<!--
 * @Description: 新增和详情审批代理模块
 * @Autor: lwq
 * @Date: 2020-07-29 11:17:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 10:51:43
 * @FilePath: \mrc-base-server-view\src\views\approver\modules\approverInfo.vue
--> 
<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_The_name_of_the')+'*'"
                               :readonly="disabled"
                               :isNational="judegNational('proxy_name')"
                               :error-messages="$errors('params','proxy_name',requiredRule.concat(nocharacter))"
                               v-model="params.proxy_name">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_note')"
                               noRequired
                               :error-messages="$errors('params','proxy_description',nocharacter)"
                               :readonly="disabled"
                               :isNational="judegNational('proxy_description')"
                               v-model="params.proxy_description">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_prompt :label="$t('label_table_name')+'*'"
                            :errMsg="$errors('params','business_data_table_name',requiredRule)"
                            :rules='false'
                            :disabled='disabled'
                            v-model="params.business_data_table_name"
                            obj="table_name">
            </mrc_ess_prompt>
            <!-- <mrc_ess_multiText :label="$t('label_table_name')+'*'"
                               :readonly="disabled"
                               :isNational="judegNational('business_data_table_name')"
                               :error-messages="$errors('params','business_data_table_name',requiredRule)"
                               v-model="params.business_data_table_name">
            </mrc_ess_multiText> -->
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @success='success'
                         :loading='btnloading'
                         v-if="!disabled"
                         @cancel='cancel'></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { updateApprovertype, detailApprovertype, addApprovertype } from '@/service/api/approvertype'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      btnloading: false,
      skeletonloading: true,
      params: {
      }
    };
  },
  validations: {
    params: {
      proxy_name: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      proxy_description: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      business_data_table_name: {
        required
      },
    }
  },
  computed: {
    agent_approval_type () {
      return { prompt_name: 'agent_approval_type', org_level_uuid: this.$store.state.userData.org_level_uuid }
    }
  },
  created () { },
  watch: {
    disabled: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_approval_business_type'
          this.$store.commit('set_page_title', 'label_edit_approval_business_type')
        }
        else {
          this.$route.meta.title = 'label_view_approval_business_type'
          this.$store.commit('set_page_title', 'label_view_approval_business_type')
        }
      }, immediate: true
    }
  },
  async mounted () {
    this.national('mrbase_sys_flow_proxy_approval_type')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
  },
  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await detailApprovertype({ uuid: this.$store.state.uuid, })
      if (res.code == 200) {
        this.params = res.data
      }
      this.skeletonloading = false
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.btnloading = true
      if (this.$store.state.uuid) {
        const res = await updateApprovertype(this.$deletefield(null, this.params))
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_The_operation_was_successful') })
          this.$emit('changeReadonly')
          await this.getDetail()
        }
      }
      else {
        const res = await addApprovertype(this.params)
        if (res.code == 200) {
          this.$Message({ text: this.$t('message_added_successfully') })
          this.$router.push({ name: 'approvertype' })
        }
      }
      this.btnloading = false
    },
    async cancel () {
      if (this.$store.state.uuid) {
        this.$emit('changeReadonly')
        await this.getDetail()
      }
      else {
        this.$myConfirm({ content: this.$t('message_Confirm_the_cancellation_of_the_edit') })
          .then(() => {
            this.$router.go(-1)
          }).catch(() => { })
      }

    },
  },
};
</script>

<style scoped>
</style>
